var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Setting"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.9966 19.4444C15.9015 19.4444 17.4457 17.9002 17.4457 15.9953C17.4457 14.0904 15.9015 12.5461 13.9966 12.5461C12.0917 12.5461 10.5474 14.0904 10.5474 15.9953C10.5474 17.9002 12.0917 19.4444 13.9966 19.4444Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.53171 20.3145C6.15056 19.6579 5.85855 18.9536 5.66339 18.22L7.11031 16.4092C7.09393 16.1323 7.09393 15.8547 7.11031 15.5779L5.66425 13.7671C5.85908 13.0334 6.15049 12.3288 6.53085 11.6717L8.83402 11.4131C9.01794 11.2058 9.21403 11.0098 9.42124 10.8258L9.67993 8.52353C10.336 8.14499 11.0395 7.85531 11.7718 7.66211L13.5826 9.10903C13.8595 9.09264 14.137 9.09264 14.4139 9.10903L16.2247 7.66297C16.9584 7.8578 17.663 8.14921 18.3201 8.52957L18.5787 10.8327C18.7859 11.0167 18.982 11.2127 19.166 11.42L21.4683 11.6786C21.8494 12.3352 22.1414 13.0395 22.3366 13.7731L20.8897 15.5839C20.9061 15.8608 20.9061 16.1384 20.8897 16.4152L22.3357 18.226C22.1423 18.9595 21.8523 19.6641 21.4734 20.3214L19.1703 20.58C18.9863 20.7873 18.7903 20.9833 18.583 21.1673L18.3244 23.4696C17.6678 23.8507 16.9635 24.1427 16.2299 24.3379L14.4191 22.891C14.1422 22.9074 13.8647 22.9074 13.5878 22.891L11.777 24.337C11.0435 24.1436 10.3389 23.8536 9.68165 23.4747L9.42297 21.1716C9.21575 20.9877 9.01967 20.7916 8.83575 20.5844L6.53171 20.3145Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.e9b31b53ce93775445f7a0f2243caa7b.svg";
export { ForwardRef as ReactComponent };